import { render, staticRenderFns } from "./course-manage-bulk-actions.vue?vue&type=template&id=0619dcee&"
import script from "./course-manage-bulk-actions.vue?vue&type=script&lang=ts&"
export * from "./course-manage-bulk-actions.vue?vue&type=script&lang=ts&"
import style0 from "./course-manage-bulk-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports